import React, { createContext } from 'react'
import { useSelector } from 'react-redux'

const initialState = {
    client: null    
};

const ClientContext = createContext({
    ...initialState,
    init: () => Promise.resolve(),
    get: () => Promise.resolve(),     
});



export const ClientProvider = (props) => {
    
    const { client } = useSelector(state => state?.clients)

    
    
    return (
        <ClientContext.Provider
            value={{
                ...client,          
            }}>
            {props.children}            
        </ClientContext.Provider>
    );
}

export  {ClientContext}